import { IMapSlotClose } from 'common/tile/tile-body-header-v2-element.js';
import { GenericMarkerDescription } from 'components-modules/map-slot-generic/index.js';
import { TrafficCameraSlideProps } from 'components-modules/overlay/traffic-overlay-slot-image.js';
import { IModule } from 'redux-state/layout/types.js';
import { CameraImagePanelV1 } from './camera-image.js';

export const TrafficCamMapSlot = ({ config, modulePath }: IModule<TrafficCameraSlideProps & IMapSlotClose>) => {
  const { key, value } = config;
  return (
    <GenericMarkerDescription key={key} dataModule="traffic-cam-comp" config={config} modulePath={modulePath}>
      <CameraImagePanelV1 value={value} />
    </GenericMarkerDescription>
  );
};
